import axios from 'axios'
export default {

    getBookingConfig(){
        let params = new URLSearchParams();
        params.append("operation", "getBookingWidget")
        params.append("site_id" , site_id)
        params.append("lang_selected" , langSelected)
        return axios.post(`${ site_url }ajax/functions.php`,params)
    },
    
    getDayPricesFromTravelTripper(hotelId, portaId, rateCode = null, numberOfMonths = null){
        const  params   = new URLSearchParams(),
               url      = `${site_url}ajax/functions.php` 
        params.append("hotel_id",hotelId);
        params.append("portal_id",portaId);
        if(rateCode !== null)
            params.append("rate_code",rateCode);
        if(numberOfMonths !== null )
            params.append("number_of_months",numberOfMonths);
        params.append("operation", 'getDayPricesFromTravelTripper');
        return axios.post(url,params);
    }
}